var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDmnPreview = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 166,
  height: 89,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 166,
  height: 89,
  fill: "#F4F4F4",
  rx: 3
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#8D8D8D",
  fillOpacity: 0.5,
  d: "M9.232 12h147.535v20H9.232z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#E5E5E5",
  d: "M9.232 12h147.535v20H9.232z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h43v20H0z",
  style: {
    mixBlendMode: "multiply"
  },
  transform: "translate(9 35)"
}), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#E5E5E5",
  d: "M9 35h43v20H9z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h102v20H0z",
  style: {
    mixBlendMode: "multiply"
  },
  transform: "translate(55 35)"
}), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#E5E5E5",
  d: "M55 35h102v20H55z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h43v20H0z",
  style: {
    mixBlendMode: "multiply"
  },
  transform: "translate(9 58)"
}), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#E5E5E5",
  d: "M9 58h43v20H9z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h102v20H0z",
  style: {
    mixBlendMode: "multiply"
  },
  transform: "translate(55 58)"
}), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#E5E5E5",
  d: "M55 58h102v20H55z"
})));
export default SvgDmnPreview;